'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _reactRouterRedux = require('react-router-redux');

var _components = require('../../components');

var _EmailInput = require('../../components/EmailInput/EmailInput');

var _BaseButton = require('../../components/BaseButton/BaseButton');

var _Checkbox = require('../../components/Checkbox/Checkbox');

var _Captcha = require('../../helpers/Captcha');

var _DefaultString = require('../../helpers/DefaultString');

var _Error = require('../../helpers/Error');

var _LinkAccount = require('../../helpers/LinkAccount');

var _PopupType = require('../../helpers/PopupType');

var _Product = require('../../helpers/Product');

var _Password = require('../../helpers/Password');

var _Router = require('../../helpers/Router');

var _Cookie = require('../../helpers/Cookie');

var _ValidateTvCode = require('../../helpers/ValidateTvCode');

var _auth = require('../../redux/modules/auth');

var _popup = require('../../redux/modules/popup');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _SignUpEmail = require('./SignUpEmail.scss');

var _SignUpEmail2 = _interopRequireDefault(_SignUpEmail);

var _backArrow = require('../../../res/images/common/back-arrow.svg');

var _backArrow2 = _interopRequireDefault(_backArrow);

var _karaoke_tsm_pineapple = require('../../../res/images/welcome/karaoke_tsm_pineapple.png');

var _karaoke_tsm_pineapple2 = _interopRequireDefault(_karaoke_tsm_pineapple);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NB_DAY_FREE_TRIAL = 7;

var SignUpEmail = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    appInfo: state.appInfo,
    auth: state.auth,
    captcha: state.captcha };
}, { changePopupType: _popup.changePopupType, createAccount: _auth.createAccount, createAccountV2: _auth.createAccountV2, editEmailMessageError: _auth.editEmailMessageError, emailExists: _auth.emailExists, editTermsAndPrivacy: _auth.editTermsAndPrivacy, tvFlowStarted: _auth.tvFlowStarted, pushState: _reactRouterRedux.push, userPassUpgrade: _auth.userPassUpgrade }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(SignUpEmail, _Component);

  function SignUpEmail(props) {
    (0, _classCallCheck3.default)(this, SignUpEmail);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SignUpEmail.__proto__ || (0, _getPrototypeOf2.default)(SignUpEmail)).call(this, props));

    _this.state = {
      captchaError: false,
      loading: false,
      password: '',
      passwordError: false,
      tvCodeError: false
    };

    _this.getTitle = function () {
      return _DefaultString.translations.CreateAnAccount;
    };

    _this.getTitleBlock = function () {
      var titleMessage = _this.getTitle();
      return _react2.default.createElement(
        'div',
        { className: _SignUpEmail2.default.title },
        _react2.default.createElement(_reactIntl.FormattedMessage, titleMessage),
        ' \xA0',
        _react2.default.createElement(
          'span',
          { onClick: _this.navLoginOptions, className: _SignUpEmail2.default.link },
          _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.Or),
          ' ',
          _react2.default.createElement(_reactIntl.FormattedMessage, _this.getLoginText())
        )
      );
    };

    _this.getLoginText = function () {
      return _DefaultString.translations.Login;
    };

    _this.getLegal = function () {
      var productName = _this.props.auth.productName;
      var formatMessage = _this.props.intl.formatMessage;

      var termsLink = _react2.default.createElement(_reactIntl.FormattedHTMLMessage, (0, _extends3.default)({}, _DefaultString.translations.TermsConditionsLink, {
        values: {
          link: (0, _Product.getTermsString)(formatMessage, productName, _this.props.appInfo.excludeHeader)
        }
      }));
      var privacyLink = _react2.default.createElement(_reactIntl.FormattedHTMLMessage, (0, _extends3.default)({}, _DefaultString.translations.PrivacyPolicyLink, {
        values: {
          link: (0, _Product.getPrivacyString)(formatMessage, productName, _this.props.appInfo.excludeHeader)
        }
      }));
      return _react2.default.createElement(
        'div',
        { className: _SignUpEmail2.default.legalMessage },
        _react2.default.createElement(_reactIntl.FormattedMessage, (0, _extends3.default)({}, _DefaultString.translations.ApproveAgreementsMessage, {
          values: { termsLink: termsLink, privacyLink: privacyLink }
        }))
      );
    };

    _this.getSubmitButton = function () {
      var _this$props$auth = _this.props.auth,
          productName = _this$props$auth.productName,
          bypassMaintenance = _this$props$auth.bypassMaintenance,
          emailErrorMessage = _this$props$auth.emailErrorMessage;

      var confirmTheme = productName === _Product.PRODUCT_NAMES.Classica || productName === _Product.PRODUCT_NAMES.Qello || _this.isMusic ? _BaseButton.ButtonTheme.CallToAction : '';
      return _react2.default.createElement(_components.BaseButton, {
        className: _SignUpEmail2.default.submit,
        onClick: _this.submitCreateAccount,
        buttonString: _DefaultString.translations.Continue,
        isInactive: _config2.default.maintenance && bypassMaintenance !== "true" || !!emailErrorMessage || _this.state.passwordError,
        loading: _this.state.loading,
        theme: confirmTheme
      });
    };

    _this.getEmailPlaceholder = function () {
      var _this$props$auth2 = _this.props.auth,
          productName = _this$props$auth2.productName,
          clientId = _this$props$auth2.clientId;

      return (0, _Product.isKaraokeTsm)(productName, clientId) ? _DefaultString.translations.Email : _DefaultString.translations.EmailAddress;
    };

    _this.getOrText = function () {
      return _DefaultString.translations.OrContinueWith;
    };

    _this.getOrComponent = function () {
      var orText = _this.getOrText();
      return _react2.default.createElement(
        'div',
        { className: _SignUpEmail2.default.optionSeparator },
        _react2.default.createElement(_reactIntl.FormattedMessage, orText)
      );
    };

    _this.getTvCodeErrorMessage = function () {
      var tvCodeErrorMessage = _DefaultString.translations.ErrorRetryTitle;
      return _this.state.tvCodeError ? _react2.default.createElement(
        'div',
        { className: _SignUpEmail2.default.errorMessage },
        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, tvCodeErrorMessage)
      ) : '';
    };

    _this.getFormFooter = function () {
      var element = null;
      var _this$props$auth3 = _this.props.auth,
          productName = _this$props$auth3.productName,
          clientId = _this$props$auth3.clientId,
          isMobile = _this$props$auth3.isMobile;

      if ((0, _Product.isKaraokeTsm)(productName, clientId) && !isMobile) {
        element = _react2.default.createElement(
          'div',
          { className: _SignUpEmail2.default.karaokePineapple },
          _react2.default.createElement('img', { src: _karaoke_tsm_pineapple2.default, alt: 'Karaoke Pineapple' })
        );
      }
      return element;
    };

    _this.clearInput = function () {
      _this.setState({ password: '' });
    };

    _this.editCaptchaError = function (captchaError) {
      _this.setState({ captchaError: captchaError });
    };

    _this.editLoadingState = function (loadingState) {
      _this.setState({ loading: loadingState });
    };

    _this.handleEnterKey = function (event) {
      if (event.key === 'Enter') {
        _this.submitCreateAccount();
      }
    };

    _this.isPasswordValid = function () {
      return _this.state.password && (0, _Password.passwordValid)(_this.state.password);
    };

    _this.handlePasswordBlur = function () {
      if (!_this.isPasswordValid()) {
        _this.handlePasswordError(true);
      }
    };

    _this.handlePasswordChange = function (password) {
      _this.setState({ password: password });
    };

    _this.handlePasswordError = function (error) {
      _this.setState({ passwordError: error });
    };

    _this.submitCreateAccount = function () {
      var _this$props$auth4 = _this.props.auth,
          email = _this$props$auth4.email,
          emailErrorMessage = _this$props$auth4.emailErrorMessage;

      var hasEmailPassEntry = email && _this.isPasswordValid();

      if (!email) {
        _this.props.editEmailMessageError(_EmailInput.EmailErrorMessage.InvalidEmail);
      } else if (!emailErrorMessage && !_this.state.passwordError && hasEmailPassEntry) {
        _this.editLoadingState(true);

        _this.captchaEl.getWrappedInstance().executeReCaptcha();
      } else {
        _this.handleEmailOnBlur();
        _this.handlePasswordBlur();
      }
    };

    _this.skipAgreements = function () {
      var productName = _this.props.auth.productName;

      return productName === _Product.PRODUCT_NAMES.Music || productName === _Product.PRODUCT_NAMES.Karaoke;
    };

    _this.reCaptchaValidated = function (captchaToken) {
      if (captchaToken) {
        if (_this.skipAgreements()) {
          _this.props.editTermsAndPrivacy(true);
        }

        if (_this.props.auth.sessionId) {
          _this.props.userPassUpgrade(_this.props.auth.sessionId, _this.props.auth.email, _this.state.password);
        } else {
          _this.props.createAccountV2(_this.props.auth.email, _this.state.password);
        }
      } else {
        _this.editLoadingState(false);
        _this.editCaptchaError(true);
      }
    };

    _this.navLoginOptions = function () {
      _this.props.pushState((0, _Router.getPathWithWelcome)(_Router.RouterConst.LoginOptions));
    };

    _this.isMusic = _this.props.auth.realm === _Product.REALM_NAMES.Stingray && _this.props.auth.productName === _Product.PRODUCT_NAMES.Music;
    return _this;
  }

  (0, _createClass3.default)(SignUpEmail, [{
    key: 'componentDidMount',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var tvCode, response, _tvCode, error, tvData, params, clientId;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                (0, _LinkAccount.setProviderInStorageForLinkAccount)(this.props.auth);

                (0, _LinkAccount.setOldSessionIdInStorage)(this.props.auth.realm);

                // check if we're on the TV flow
                tvCode = sessionStorage.getItem(_Cookie.tvCodeSessionStorageName);

                if (!tvCode) {
                  _context.next = 28;
                  break;
                }

                _context.prev = 4;
                _context.next = 7;
                return (0, _ValidateTvCode.validateTvCode)(tvCode);

              case 7:
                response = _context.sent;

                if (!response) {
                  _context.next = 20;
                  break;
                }

                _tvCode = response.tvCode, error = response.error, tvData = response.tvData;
                params = new URLSearchParams(window.location.search);
                clientId = params.get("client_id");

                if (!(!error && clientId)) {
                  _context.next = 17;
                  break;
                }

                this.props.tvFlowStarted(_tvCode, clientId, tvData.sessionId);
                sessionStorage.setItem(_Cookie.tvCodeSessionStorageName, _tvCode);
                _context.next = 18;
                break;

              case 17:
                throw new Error('Cookie ' + _Cookie.tvCodeSessionStorageName + ' invalid.');

              case 18:
                _context.next = 21;
                break;

              case 20:
                throw new Error('Could not validate ' + _Cookie.tvCodeSessionStorageName);

              case 21:
                _context.next = 28;
                break;

              case 23:
                _context.prev = 23;
                _context.t0 = _context['catch'](4);

                console.error(_context.t0);
                this.setState({ tvCodeError: _context.t0 });
                if (_context.t0.response.status === 400) {
                  this.props.pushState('/' + this.props.auth.productName.toLowerCase() + '/' + _Router.RouterConst.TV);
                }

              case 28:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 23]]);
      }));

      function componentDidMount() {
        return _ref.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.auth.creatingAccount && !nextProps.auth.creatingAccount) {
        if (nextProps.auth.error) {
          this.clearInput();
          this.editLoadingState(false);

          if (nextProps.auth.error.response.body.code === _Error.ErrorConst.UserNameAlreadyExists) {
            this.props.pushState((0, _Router.getPathWithWelcome)(_Router.RouterConst.ExistingAccount));
          } else if (nextProps.auth.error.response.body.code === _Error.ErrorConst.InvalidCaptcha) {
            this.props.changePopupType(_PopupType.PopupId.CreateAccountError);
          }
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var hasCaptcha = this.props.captcha.needCaptcha;
      var bypassMaintenance = this.props.auth.bypassMaintenance;

      var title = this.getTitleBlock();
      var emailPlaceholder = this.getEmailPlaceholder();
      var legal = this.getLegal();
      var submitButton = this.getSubmitButton();
      var orComponent = this.getOrComponent();
      var socialLoginComponent = _react2.default.createElement(_components.SocialLoginButtons, null);
      var tvCodeErrorMessageComponent = this.getTvCodeErrorMessage();
      var formFooter = this.getFormFooter();

      var inMaintenance = _config2.default.maintenance && bypassMaintenance !== "true";

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          {
            className: _SignUpEmail2.default.signUpEmail + (hasCaptcha ? " " + _SignUpEmail2.default.needCaptcha : "")
          },
          this.isMusic ? _react2.default.createElement(
            'div',
            { className: _SignUpEmail2.default.backButton },
            _react2.default.createElement(_components.BackButton, {
              className: _SignUpEmail2.default.back,
              pathname: this.props.location.pathname,
              icon: _backArrow2.default
            })
          ) : null,
          inMaintenance && _react2.default.createElement(
            'div',
            { className: _SignUpEmail2.default.maintenance },
            _react2.default.createElement(_components.MaintenanceBanner, null)
          ),
          _react2.default.createElement(
            'div',
            { className: _SignUpEmail2.default.content + ' ' + (inMaintenance ? _SignUpEmail2.default.contentMaintenance : "") },
            title,
            this.isMusic ? legal : null,
            _react2.default.createElement(
              'div',
              { className: _SignUpEmail2.default.upOptionWrapper },
              _react2.default.createElement(_components.EmailInput, {
                handleEnterKey: this.handleEnterKey,
                intl: this.props.intl,
                placeholder: emailPlaceholder,
                handleParentOnBlur: this.handleEmailOnBlur }),
              _react2.default.createElement(_components.PasswordInput, {
                editPassword: this.handlePasswordChange,
                handleEnterKey: this.handleEnterKey,
                intl: this.props.intl,
                name: 'password',
                password: this.state.password,
                placeholder: _DefaultString.translations.Password,
                handleErrorState: this.handlePasswordError,
                handleOnBlur: this.handlePasswordBlur,
                error: this.state.passwordError,
                errorString: _DefaultString.translations.PasswordMinError }),
              _react2.default.createElement(
                'div',
                { className: _SignUpEmail2.default.rememberMeWrapper },
                _react2.default.createElement(_components.RememberMe, {
                  className: _SignUpEmail2.default.rememberMe,
                  theme: _Checkbox.CheckboxTheme.APP_COLOR })
              )
            ),
            _react2.default.createElement(_components.Captcha, {
              ref: function ref(el) {
                _this2.captchaEl = el;
              },
              error: this.state.captchaError,
              editCaptchaError: this.editCaptchaError,
              onReCaptchaValidated: this.reCaptchaValidated,
              captchaTypeRequired: SignUpEmail.beCalls
            }),
            tvCodeErrorMessageComponent,
            submitButton,
            orComponent,
            socialLoginComponent,
            formFooter,
            !this.isMusic ? _react2.default.createElement(
              'div',
              { className: _SignUpEmail2.default.componentWrapper },
              legal
            ) : null
          )
        )
      );
    }
  }]);
  return SignUpEmail;
}(_react.Component), _class2.propTypes = {
  appInfo: _react.PropTypes.object,
  location: _react.PropTypes.object,
  auth: _react.PropTypes.object,
  captcha: _react.PropTypes.object,
  changePopupType: _react.PropTypes.func,
  createAccount: _react.PropTypes.func.isRequired,
  createAccountV2: _react.PropTypes.func.isRequired,
  editEmailMessageError: _react.PropTypes.func,
  emailExists: _react.PropTypes.func.isRequired,
  editTermsAndPrivacy: _react.PropTypes.func.isRequired,
  intl: _reactIntl.intlShape.isRequired,
  tvFlowStarted: _react.PropTypes.func,
  pushState: _react.PropTypes.func.isRequired,
  userPassUpgrade: _react.PropTypes.func.isRequired
}, _class2.beCalls = [_Captcha.CaptchaCallNames.EmailExists, _Captcha.CaptchaCallNames.CreateAccount, _Captcha.CaptchaCallNames.FacebookLogin], _temp)) || _class);
exports.default = (0, _reactIntl.injectIntl)(SignUpEmail);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/SignUpEmail/SignUpEmail.js
// module id = 2020
// module chunks = 0